import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import FeaturesPage from './pages/FeaturesPage';
import DocsPage from './pages/DocsPage';
import GettingStartedPage from './pages/GettingStartedPage';
import './assets/styles/index.css';

function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto py-20 text-center">
      <h1 className="text-4xl text-dblift-blue-dark">{t('notFound.title')}</h1>
      <p className="mt-4">{t('notFound.description')}</p>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/getting-started" element={<GettingStartedPage />} />
            {/* Other routes will be added here */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;